export const CAPABILITIES_LIST = [
  {
    text: 'Продажи',
    color: '#FAEBD0',
    list: [
      {
        text: 'Интеграции',
        icon: 'integrations-icon.svg'
      },
      {
        text: 'Настройка входящих',
        icon: 'phone-incoming-icon.svg'
      },
      {
        text: 'Разные операторы',
        icon: 'phone-icon.svg'
      }
    ]
  },
  {
    text: 'Аналитика',
    color: '#D6D2E8',
    list: [
      {
        text: 'Отчеты',
        icon: 'reports-icon.svg'
      },
      {
        text: 'Дашборды',
        icon: 'dashboard-icon.svg'
      },
      {
        text: 'Статистика',
        icon: 'statistic-icon.svg'
      }
    ]
  },
  {
    text: 'Контроль качества',
    color: '#E7E7E7',
    list: [
      {
        text: 'История звонков',
        icon: 'history-icon.svg'
      },
      {
        text: 'Запись разговоров',
        icon: 'record-icon.svg'
      },
      {
        text: 'Уведомления',
        icon: 'bell-icon.svg'
      }
    ]
  },
  {
    text: 'Маркетинг',
    color: '#D4D3FF',
    list: [
      {
        text: 'Callback',
        icon: 'callback-icon.svg'
      },
      {
        text: 'Автоинформатор',
        icon: 'autoinform-icon.svg'
      }
    ]
  },
  {
    text: 'Техподдержка',
    color: '#FBDDD1',
    list: [
      {
        text: 'Автоперезвон',
        icon: 'phone-recall-icon.svg'
      },
      {
        text: 'Оценка качеcтва',
        icon: 'phone-star-icon.svg'
      }
    ]
  }
]